import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Checkbox, Flex, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import cloneDeep from 'lodash.clonedeep';

import { updateTableColumnConfigurations } from '../../../../redux/actions/table-configurations';

import AppModal from '../../../../components/AppModal';

const EditableTableColumnsModal = ({ tableId, onClose }) => {
  if (!tableId) {
    return null;
  }

  const dispatch = useDispatch();
  const configurations = useSelector(state => state.tableConfigurations.configurations);

  const initialColumns = configurations.find(({ id }) => id === tableId)?.columns || [];
  const [columnsState, setColumnsState] = useState(() => cloneDeep(initialColumns).sort((a, b) => a.order - b.order));

  const handleEdit = (index, key, value) => {
    setColumnsState(prevState => prevState.map((col, i) => (i === index ? { ...col, [key]: value } : col)));
  };

  const moveColumn = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= columnsState.length) return;

    const updatedColumns = [...columnsState];

    [updatedColumns[index].order, updatedColumns[newIndex].order] = [
      updatedColumns[newIndex].order,
      updatedColumns[index].order
    ];

    updatedColumns.sort((a, b) => a.order - b.order);
    setColumnsState(updatedColumns);
  };

  const handleSave = () => {
    dispatch(
      updateTableColumnConfigurations(
        tableId,
        columnsState.map(({ id, title, description, is_visible }) => ({
          id,
          title,
          description,
          is_visible: !!is_visible
        }))
      )
    );
    onClose();
  };

  return (
    <AppModal
      title="Edit Columns"
      isOpen={true}
      confirmButtonText="Save"
      handleCancel={onClose}
      handleConfirm={handleSave}>
      <Flex gap="small" vertical={true}>
        {columnsState.map((col, index) => {
          return (
            <Flex align="center" gap="small" vertical={false} key={col.id}>
              <Checkbox checked={col.is_visible} onChange={e => handleEdit(index, 'is_visible', e.target.checked)}>
                Visible
              </Checkbox>
              <Flex align="center" gap="small" vertical={false}>
                <span>Order</span>
                <Button
                  size="small"
                  icon={<ArrowUpOutlined />}
                  disabled={index === 0}
                  onClick={() => moveColumn(index, -1)}
                />
                <Button
                  size="small"
                  icon={<ArrowDownOutlined />}
                  disabled={index === columnsState.length - 1}
                  onClick={() => moveColumn(index, 1)}
                />
              </Flex>
              <Input
                placeholder="Column Name"
                maxLength={255}
                value={col.title}
                onChange={e => handleEdit(index, 'title', e.target.value)}
              />
              <TextArea
                placeholder="Column Description"
                maxLength={1024}
                autoSize={{ minRows: 1, maxRows: 1 }}
                value={col.description}
                onChange={e => handleEdit(index, 'description', e.target.value)}
              />
            </Flex>
          );
        })}
      </Flex>
    </AppModal>
  );
};

export default EditableTableColumnsModal;
